"use client";
import { jsx as i } from "react/jsx-runtime";
import { boxPadding as f } from "../../common/styles/mixins/boxPadding.js";
import { css as d } from "@emotion/react";
import p from "@emotion/styled";
import { COLORS as m } from "../../tokens/colors/Colors.js";
import { SHADOWS as l } from "../../tokens/shadows/Shadows.js";
import { SIZES as c } from "../../tokens/sizes/Sizes.js";
import { forwardRef as $ } from "react";
const t = $(
  ({ feNoBorder: o = !1, feNoPadding: r = !1, feStretch: a = !1, ...s }, e) => /* @__PURE__ */ i(
    b,
    {
      ...s,
      "data-comp": "card",
      feNoBorder: o,
      feNoPadding: r,
      feStretch: a,
      ref: e
    }
  )
);
t.displayName = "Card";
const O = t, b = p.div(
  ({ feNoBorder: o, feNoPadding: r, feStretch: a }) => d`
		background: ${m.white};
		border: ${!o && `1px solid ${m.gray300}`};
		border-radius: ${c.s02};
		box-shadow: ${l.md};

		${!r && f()};

		${a && d`
			block-size: 100%;
			overflow-y: auto;
		`}
	`
);
export {
  O as default
};
